import React from 'react';
import GenericList from 'src/shared/genericList';
import { useTranslation } from 'react-i18next';

export default function GroupList() {
  const { t } = useTranslation();
  const columns = [
    { field: 'group_id', headerName: 'ID', hide: true },
    {
      field: 'group_type_name',
      headerName: t('GROUP_TYPE_NAME'),
      width: 250,
      editable: true,
    },
    {
      field: 'group_name',
      headerName: t('GROUP_NAME'),
      width: 250,
      editable: true,
    },
    {
      field: 'group_code',
      headerName: t('GROUP_CODE'),
      width: 250,
      editable: true,
    },
    {
      field: 'group_order',
      headerName: t('GROUP_ORDER'),
      width: 75,
      editable: true,
      flex: 1,
    },
  ];

  return <GenericList objectName={'group'} columns={columns} rowId={'group_id'} />;
}
